import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      terminology: undefined,
    }
  },
  computed: {
    ...mapGetters('supportBusiness', {
      supportBusinesses: 'supportBusinesses',
    }),
  },
  created() {
    this.getSupportBusiness();
  },
  methods: {
    ...mapActions("supportBusiness", {
      getSupportBusiness: "REFRESH",
    }),
    imageUrl (pk) {
    const appBaseUrl =   window.configs && window.configs.VUE_APP_ROUTE_BASE_URL !== "" 
    ? window.configs.VUE_APP_CHAT_URL: process.env.VUE_APP_ROUTE_BASE_URL
    ? process.env.VUE_APP_ROUTE_BASE_URL
    : "https://advportalapi.vita.ovh";
      return `${appBaseUrl}/api/v2/documents/download/${pk}`
    },
    filterData(keyword) {
      if (this.supportBusinesses.length) {
        const data = this.supportBusinesses.filter(item => item.keyword.trim() === keyword)[0]
        if (data) {
          const { title, content, PictureId } = data
          this.terminology = {
            title,
            content,
            photo: PictureId ? this.imageUrl(PictureId) || '' : ''
          }
        } else {
          this.terminology = undefined
        }
      }
    },
    viewMoreInfo(keyword) {
      this.filterData(keyword)
      if (this.terminology) {
        this.$refs["terminologyPopup"].show();
      }
    },
  }
};
